<script setup>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3'
import { useIncidentStore } from '@/store/incident.js'
import { computed, onMounted, ref } from 'vue'
import { humanReadableTimestamp } from '@/composables/datetime'
import { useI18n } from 'vue-i18n'
import CustomNodeEditMenu from '@/components/wysiwyg-components/nodes/CustomNodeEditMenu.vue'

const props = defineProps(nodeViewProps)
const t = useI18n().t

const incidentId = props.node.attrs.incidentId
const incidentStore = useIncidentStore()
const incident = ref(null)

const chipText = computed(() => {
  if (incident.value) {
    return `${t('incidents.' + incident.value.type + '.title')} (${humanReadableTimestamp(incident.value.firstEventTimestamp)})`
  }
  return t('incidents.unknown-incident')
})

onMounted(async () => {
  if (incidentId) {
    incident.value = await incidentStore.getIncident(incidentId)
  }
})
</script>

<template>
  <node-view-wrapper
    as="div"
    class="d-inline-block"
  >
    <CustomNodeEditMenu
      :variant-parameters="{ incidentId }"
      current-variant="inline-incident"
      :variants="[
        { tag: 'inline-incident', label: 'Inline', icon: 'mdi-text' },
        { tag: 'incident-card', label: 'Card', icon: 'mdi-card-text' },
      ]"
      :is-editable="true"
      :node-props="props"
    >
      <template #element="nodeProps">
        <v-chip
          v-bind="nodeProps"
          @click="$router.push({ name: 'IncidentView', params: { incidentId } })"
        >
          {{ chipText }}
        </v-chip>
      </template>
    </CustomNodeEditMenu>
  </node-view-wrapper>
</template>

<style scoped></style>
